$(document).ready(function() {
	evenBlock();
});

$(window).on('load', function(){
	evenBlock();
});

function evenBlock() {
	var maxHeight = -1;

	if ( $( ".even-block" ).length ) {
		$('.even-block').each(function(){
			$(this).height('auto');
			maxHeight = maxHeight > $(this).height() ? maxHeight : $(this).height();
		});
		$('.even-block').each(function(){
		    $(this).height(maxHeight);
		});
	}
}

function clean(node)
{
  for(var n = 0; n < node.childNodes.length; n ++)
  {
    var child = node.childNodes[n];
    if
    (
      child.nodeType === 8 
      || 
      (child.nodeType === 3 && !/\S/.test(child.nodeValue))
    )
    {
      node.removeChild(child);
      n --;
    }
    else if(child.nodeType === 1)
    {
      clean(child);
    }
  }
}